import { useQuery } from '@tanstack/react-query';
import { $authHost } from 'app/configs/axiosConfig';
import { checkAffiliateLeadsStatus } from '../api/AffiliateLeadsApi';

interface FilteredAffiliateLeadsParams {
  skip?: number;
  take?: number;
  orderBy?: Record<string, string>;
  where?: Record<string, unknown>;
  include?: Record<string, unknown>;
  select?: Record<string, unknown>;
}

const getFilteredAffiliateLeads = async (params: FilteredAffiliateLeadsParams) => {
  const response = await $authHost.post('/affiliate-lead/filter', params);
  return response.data as { data: { items: unknown[]; totalCount: number } };
};

export const useFilteredAffiliateLeads = (params: FilteredAffiliateLeadsParams) => {
  return useQuery({
    queryKey: ['affiliateLeads', params],
    queryFn: () => getFilteredAffiliateLeads(params),
  });
};

export const useAffiliateLeadsStatusQuery = () => {
  return useQuery({
    queryKey: ['affiliateLeadsStatus'],
    queryFn: checkAffiliateLeadsStatus,
    refetchInterval: 15000, // Poll every 15 seconds
  });
};
